import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=5885f623&scoped=true&"
import script from "./PromotionForm.vue?vue&type=script&lang=js&"
export * from "./PromotionForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=5885f623&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885f623",
  null
  
)

export default component.exports